module.exports = __webpack_public_path__ + "static/media/alex.71238ae4.pdf";